import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
	selector: '[appSaveHotkey]',
})
export class SaveHotkeyDirective {
	@Input() isDisabled: boolean = false;
	@Input() hasDialogDisplayed: boolean = false;
	@Output() onSaveHotkey: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}

	@HostListener('document:keydown.alt.s', ['$event']) saveHotkey(evt: KeyboardEvent) {
		// If the save button isn't disabled and there isn't a dialog displayed over the button
		// e.g. the new Inquiry page where there is a save button and you can save the charging party and respondent dialogs
		if (!this.isDisabled && !this.hasDialogDisplayed) {
			this.onSaveHotkey.emit();
		}
	}
}
